import * as React from 'react';
import { StoryInfo } from '../../models/Story';
import * as dateFormat from 'dateformat';
import { Checkbox } from '../Common/checkbox';
import { StarCheckbox } from '../Common/starcheckbox';

export interface TeacherControls {
	markImportant: (id: string)=>void;
	markGraded: (id: string)=>void;
}

export interface DiaryProps {
	stories: StoryInfo[];
	viewStory: (id: string)=>void;
	deleteStory: (id: string)=>void;
	teacherControls?: TeacherControls;
}

export const Diary: React.SFC<DiaryProps> = (props) => {
	
	const { stories, viewStory, deleteStory, teacherControls } = props;

	let storyDOMS = [];
	for(let i = 0; i < stories.length; i++){
		let evals = [];
		for(let j = 0; j < stories[i].evaluations.length; j++){
			evals.push(<img src={stories[i].evaluations[j].image} className="am_smallicon"></img>);
		}

		let date = dateFormat(stories[i].date, "dd.mm.yyyy 'klo' HH:MM");

		let width = teacherControls ? "col-5" : "col-6";

		let teacherDOM;
		if(teacherControls) {
			teacherDOM = (<div className="col-2">
				<StarCheckbox onChange={()=>teacherControls.markImportant(stories[i]._id)} id={"important" + i} checked={stories[i].important}/>
				<Checkbox onChange={()=>teacherControls.markGraded(stories[i]._id)} id={"graded" + i} checked={stories[i].graded}/>
			</div>);
		}

		storyDOMS.push(
			<div className="row row-striped mb-1">
				<div className={width}>
					{date} {evals} 
				</div>
				{teacherDOM}
				<div className={width + " text-right"}>
					<button onClick={() => {viewStory(stories[i]._id)}} className="btn am_green-button mr-1">TOISTA TARINA</button>
					<button onClick={() => {deleteStory(stories[i]._id)}} className="btn am_red-button">POISTA</button>
				</div>
			</div>
		);
	}
	return(
		<div className="am_diarycontainer p-2">
			{storyDOMS}
		</div>
	);
};


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/narrapix/src/containers/Campaign/diary.tsx